/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: OhTzEj1YMg6z
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateStateOnChangeProp,
  generateStateValueProp,
  hasVariant,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicInputFieldUnderline.module.css"; // plasmic-import: OhTzEj1YMg6z/css

createPlasmicElementProxy;

export const PlasmicInputFieldUnderline__VariantProps = new Array(
  "status",
  "padding",
  "onSurface"
);

export const PlasmicInputFieldUnderline__ArgProps = new Array(
  "placeholder",
  "type",
  "inputName",
  "required"
);

const $$ = {};

function PlasmicInputFieldUnderline__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {
          type: "text",
          required: false
        },
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "textbox.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      },
      {
        path: "status",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.status
      },
      {
        path: "padding",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.padding
      },
      {
        path: "onSurface",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.onSurface
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <input
      data-plasmic-name={"textbox"}
      data-plasmic-override={overrides.textbox}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.input,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.textbox,
        {
          [sty.textboxonSurface_onGrey]: hasVariant(
            $state,
            "onSurface",
            "onGrey"
          ),
          [sty.textboxstatus_error]: hasVariant($state, "status", "error")
        }
      )}
      name={(() => {
        try {
          return $props.inputName;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      onChange={async (...eventArgs) => {
        (e => {
          generateStateOnChangeProp($state, ["textbox", "value"])(
            e.target.value
          );
        }).apply(null, eventArgs);
      }}
      placeholder={(() => {
        try {
          return $props.placeholder;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      ref={ref => {
        $refs["textbox"] = ref;
      }}
      required={(() => {
        try {
          return $props.required;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return undefined;
          }
          throw e;
        }
      })()}
      type={(() => {
        try {
          return $props.type;
        } catch (e) {
          if (
            e instanceof TypeError ||
            e?.plasmicType === "PlasmicUndefinedDataError"
          ) {
            return "text";
          }
          throw e;
        }
      })()}
      value={generateStateValueProp($state, ["textbox", "value"]) ?? ""}
    />
  );
}

const PlasmicDescendants = {
  textbox: ["textbox"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInputFieldUnderline__ArgProps,
          internalVariantPropNames: PlasmicInputFieldUnderline__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInputFieldUnderline__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "textbox") {
    func.displayName = "PlasmicInputFieldUnderline";
  } else {
    func.displayName = `PlasmicInputFieldUnderline.${nodeName}`;
  }
  return func;
}

export const PlasmicInputFieldUnderline = Object.assign(
  // Top-level PlasmicInputFieldUnderline renders the root element
  makeNodeComponent("textbox"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicInputFieldUnderline
    internalVariantProps: PlasmicInputFieldUnderline__VariantProps,
    internalArgProps: PlasmicInputFieldUnderline__ArgProps
  }
);

export default PlasmicInputFieldUnderline;
/* prettier-ignore-end */
